// @dynamic-i18n-keys
// Dynamic t() at line 67: template deviation.overlay.blocked${blockText} (blockText: '' | '.mature' | '.nsfg').
//   deviation.overlay.blocked
//   deviation.overlay.blocked.mature
//   deviation.overlay.blocked.nsfg
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation } from '@wix/da-papi-types';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import Hidden from '@wix/da-ds/pkg/Icons/Hidden';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useDeviationMatureFilter } from '../../../../../../utils/hooks/useDeviationMatureFilter';
import { BlockReasons } from '../../../../../../Moderation/redux/types';

interface Props {
  deviation: PapiDeviation;
  thumbWidth?: number;
  thumbHeight?: number;
  className?: string;
}

/** placeholder for various block reasons, eg mature, antisocial, etc
 * TODO: if one day we properly redo mature and such, create more specific
 * components for each block reason
 */
const BlockedMiddleContent: React.FC<Props> = ({
  thumbHeight,
  className,
  deviation,
}) => {
  const { t } = useTranslation();
  const { displayReason } = useDeviationMatureFilter(deviation);
  const isMatureBlock = [
    BlockReasons.MatureAge,
    BlockReasons.MatureFilter,
    BlockReasons.MatureLoggedOut,
    BlockReasons.StrictMatureAge,
  ].includes(displayReason as BlockReasons);
  const isNsfg = displayReason === BlockReasons.Nsfg;

  let isUnreasonablySmall = thumbHeight && thumbHeight < 150;
  let blockText = '';

  if (isMatureBlock) {
    blockText = '.mature';
    if (thumbHeight && thumbHeight < 180) {
      isUnreasonablySmall = true;
    }
  }

  if (isNsfg) {
    blockText = '.nsfg';
    if (thumbHeight && thumbHeight < 200) {
      isUnreasonablySmall = true;
    }
  }

  if (isUnreasonablySmall) {
    return (
      <HoverOnly reverseHidden>
        <ThumbMiddleContent
          icon={<Hidden size={IconSize.LARGE} disableDefaultColors />}
          className={className}
        />
      </HoverOnly>
    );
  }

  return (
    <ThumbMiddleContent
      title={t(`deviation.overlay.blocked${blockText}`)}
      subtitle={isNsfg && t('deviation.overlay.blocked.nsfg.subtitle')}
      className={className}
    />
  );
};
BlockedMiddleContent.displayName = 'BlockedMiddleContent';

export default BlockedMiddleContent;
